import { render, staticRenderFns } from "./modal-wizard.vue?vue&type=template&id=811726b4&scoped=true"
import script from "./modal-wizard.vue?vue&type=script&lang=js"
export * from "./modal-wizard.vue?vue&type=script&lang=js"
import style0 from "./modal-wizard.vue?vue&type=style&index=0&id=811726b4&prod&lang=css"
import style1 from "./modal-wizard.vue?vue&type=style&index=1&id=811726b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811726b4",
  null
  
)

export default component.exports